import { Component, OnInit } from '@angular/core';
import { Control } from '../../shared/models/Flow';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  public manageInfo: Control[] = [];
  constructor() { }

  ngOnInit() {
    const controlFeature = < Control > ({ featureName: 'ManageFeature', controlName: 'Manage Feature' });
    this.manageInfo.push(controlFeature);
    const control = < Control > ({ featureName: 'ManageModelYear', controlName: 'Manage Model And Year' });
    this.manageInfo.push(control);
  }

}
